




import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const CreativeMediaBranding = () => {
  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      {/*  HERO SECTION  */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1561070791-2526d30994b5?w=1920&q=80')`,
          }}
        />
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        <div className="relative z-10 text-center px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8"
          >
            Healthcare Creative, Media & Branding
          </motion.h1>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all"
            >
              Home
            </Link>
            <span className="text-white text-2xl">|</span>
            <Link 
              to="/services" 
              className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all"
            >
              Services
            </Link>
            <span className="text-white text-2xl">|</span>
            <span className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold">
              Creative, Media & Branding
            </span>
          </motion.div>
        </div>
      </section>

      {/*  CONTENT SECTION  */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left - Image & Tagline */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              {/* Tag */}
              <span className="inline-block px-4 py-2 border border-gray-300 rounded-md text-gray-600 text-sm mb-6">
                HEALTHCARE BRANDING
              </span>
              
              {/* Tagline */}
              <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-8">
                The Leading <span className="text-[#19354a]">Healthcare Creative & BrandingPartner</span> To Elevate Your Medical Practice Identity!
              </h2>
              
              <img 
                src="/images/meta14.png" 
                alt="Healthcare Creative & Branding"
                className="w-full max-w-[450px] h-auto mx-auto"
              />
            </motion.div>

            {/* Right - Content */}
            <div>
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                In a competitive healthcare market, standing out requires more than just excellent patient care—it demands a compelling visual identity that builds trust and credibility. Your medical practice's brand is often the first impression potential patients have, and it speaks volumes about your professionalism and quality of care before they even walk through your door.
              </motion.p>
              
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                At Docmize, we're passionate about <strong className="text-[#19354a]">bringing healthcare brands to life through professional medical visuals</strong>. From medical practice logos and brand identity to patient education materials and healthcare social media content, our creative team transforms your vision into compelling visual stories that resonate with patients and build trust.
              </motion.p>

              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                Whether you're launching a new medical practice, rebranding your clinic, or need professional healthcare content for your marketing campaigns, our designers and medical content creators deliver creative solutions that capture attention and communicate your commitment to patient care.
              </motion.p>

              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="text-gray-900 font-semibold leading-relaxed mb-8"
              >
                Make your medical practice unforgettable. Partner with Docmize and let's create something extraordinary together!
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
              >
                <Link 
                  to="/contact" 
                  className="inline-block px-8 py-4 bg-[#19354a] text-white rounded-lg font-semibold hover:bg-[#0f2133] transition-all"
                >
                  GET A QUOTE
                </Link>
              </motion.div>
            </div>

          </div>
        </div>
      </section>

      {/*  WHY CHOOSE US - BLUE SECTION  */}
      <section className="relative py-20 overflow-hidden">
        <div 
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(135deg, #0f1c3f 0%, #1a2d5e 50%, #152349 100%)'
          }}
        />
        
        <div className="absolute inset-0 overflow-hidden">
          <div 
            className="absolute inset-0"
            style={{
              backgroundImage: `repeating-linear-gradient(
                45deg,
                transparent,
                transparent 50px,
                rgba(59, 130, 246, 0.1) 50px,
                rgba(59, 130, 246, 0.1) 52px
              )`
            }}
          />
          <div className="absolute top-0 left-[20%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-500/20 to-transparent transform rotate-[30deg] origin-top"></div>
          <div className="absolute top-0 left-[40%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-400/30 to-transparent transform rotate-[30deg] origin-top"></div>
          <div className="absolute top-0 left-[60%] w-[3px] h-full bg-gradient-to-b from-transparent via-blue-500/20 to-transparent transform rotate-[30deg] origin-top"></div>
          <div className="absolute top-0 left-[80%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-400/15 to-transparent transform rotate-[30deg] origin-top"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6">
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-4">
              Why Choose Our Healthcare Creative Services?
            </h2>
            <p className="text-white/70 text-lg">
              Here's why doctors and hospitals trust us with their medical practice branding:
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-x-16 gap-y-8 max-w-5xl mx-auto">
            
            <div className="space-y-8">
              <motion.div 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Professional medical practice logos and brand identity that builds trust</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Healthcare-compliant graphic design for patient materials and forms</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Engaging patient education and health awareness content</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">High-converting medical practice ad creatives and banners</p>
              </motion.div>
            </div>

            <div className="space-y-8">
              <motion.div 
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Professional patient testimonial and practice video editing</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Medical procedure explainer videos and motion graphics</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Healthcare marketing collateral including brochures and flyers</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Consistent medical brand guidelines across all patient touchpoints</p>
              </motion.div>
            </div>

          </div>
        </div>
      </section>

      {/*  OUR SERVICES SECTION  */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
              Our Healthcare Creative & Branding Services
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Comprehensive creative solutions to build and elevate your medical practice brand
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            
            {/* Service 1 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Medical Practice Branding</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Professional logos and comprehensive brand identity systems for healthcare practices.
              </p>
            </motion.div>

            {/* Service 2 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Healthcare Graphic Design</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Professional designs for patient materials, forms, and medical documentation.
              </p>
            </motion.div>

            {/* Service 3 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Medical Social Media Content</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Engaging health content and patient education visuals for social platforms.
              </p>
            </motion.div>

            {/* Service 4 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Healthcare Ad Creatives</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                High-converting ad designs for medical practice patient acquisition campaigns.
              </p>
            </motion.div>

            {/* Service 5 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.5 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Medical Video Production</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Professional editing for patient testimonials, practice tours, and healthcare content.
              </p>
            </motion.div>

            {/* Service 6 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.6 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Medical Explainer Videos</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Animated procedure explanations and health education motion graphics.
              </p>
            </motion.div>

            {/* Service 7 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.7 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Medical Presentations</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Professional pitch decks and presentations for healthcare proposals.
              </p>
            </motion.div>

            {/* Service 8 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.8 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Healthcare Print Materials</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Brochures, appointment cards, signage, and all medical practice collateral.
              </p>
            </motion.div>

          </div>
        </div>
      </section>

      {/*  ENTRUST US SECTION  */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left - Content */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-2">
                Entrust us to Craft
              </h2>
              <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
                Your Medical Practice Identity,
              </h2>
              <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-2">
                Stand Out from Competing Practices
              </h3>
              <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-8">
                and Build Patient Trust.
              </h3>

              {/* Checklist Items */}
              <div className="space-y-5">
                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.1 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Create a professional medical practice brand identity that builds immediate patient trust and credibility.
                  </p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.2 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Produce engaging patient education content that positions your practice as a trusted healthcare authority.
                  </p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.3 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Design high-converting healthcare ad creatives that attract quality patients to your medical practice.
                  </p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.4 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Create professional patient testimonial videos and medical procedure explainers that inform and reassure.
                  </p>
                </motion.div>
              </div>
            </motion.div>

            {/* Right - Image */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="flex justify-center"
            >
              <img 
                src="/images/creative.png" 
                alt="Craft Your Medical Practice Identity"
                className="w-full max-w-[500px] h-auto"
              />
            </motion.div>

          </div>
        </div>
      </section>

      {/*  BENEFITS SECTION  */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
              Reap the Benefits of Healthcare Creative Services
            </h2>
            <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-6">
              AT <span className="text-[#19354a]">DOCMIZE</span>
            </h3>
            <p className="text-gray-600 max-w-4xl mx-auto leading-relaxed">
              Our healthcare creative process is designed to deliver professional medical visuals that align with your practice values and resonate with patients.
            </p>
          </motion.div>

          {/* Benefit 1 - Image Right */}
          <div className="grid lg:grid-cols-2 gap-0 mb-8">
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-[#fff4e6] p-6 lg:p-10 flex items-center border-l-4 border-[#19354a]"
            >
              <div>
                <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-4">
                  Medical Brand Discovery & Strategy
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  We start by understanding your medical specialty, patient demographics, and practice values. This foundation ensures every creative decision aligns with healthcare standards and speaks to your ideal patients while building trust.
                </p>
              </div>
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-[#e8f4fc]"
            >
              <img 
                src="/images/meta10.png" 
                alt="Medical Brand Discovery"
                className="w-full h-full min-h-[280px] object-cover"
              />
            </motion.div>
          </div>

          {/* Benefit 2 - Image Left */}
          <div className="grid lg:grid-cols-2 gap-0 mb-8">
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-[#e6f7f0] order-2 lg:order-1"
            >
              <img 
                src="/images/creative2.png" 
                alt="Healthcare Creative Design"
                className="w-full h-full min-h-[280px] object-cover"
              />
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-[#e6f2e6] p-6 lg:p-10 flex items-center order-1 lg:order-2 border-r-4 border-[#E85A2C]"
            >
              <div>
                <h3 className="text-2xl lg:text-3xl font-bold text-[#E85A2C] mb-4">
                  Healthcare Creative Design & Concepts
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Our healthcare designers create professional medical concepts for your review. We iterate based on your feedback until we achieve the perfect visual representation that communicates professionalism and care.
                </p>
              </div>
            </motion.div>
          </div>

          {/* Benefit 3 - Image Right */}
          <div className="grid lg:grid-cols-2 gap-0 mb-8">
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-[#f0e6f7] p-6 lg:p-10 flex items-center border-l-4 border-[#19354a]"
            >
              <div>
                <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-4">
                  Medical Content Production
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  From patient education materials to healthcare videos, we produce all the content you need for your medical marketing. Our team ensures HIPAA compliance and professional medical standards across all platforms.
                </p>
              </div>
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-[#e6e9f7]"
            >
              <img 
                src="/images/creative3.png" 
                alt="Medical Content Production"
                className="w-full h-full min-h-[280px] object-cover"
              />
            </motion.div>
          </div>

          {/* Benefit 4 - Image Left */}
          <div className="grid lg:grid-cols-2 gap-0">
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-[#fce8e8] order-2 lg:order-1"
            >
              <img 
                src="/images/meta6.png" 
                alt="Medical Brand Guidelines"
                className="w-full h-full min-h-[280px] object-cover"
              />
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-[#fff0e6] p-6 lg:p-10 flex items-center order-1 lg:order-2 border-r-4 border-[#E85A2C]"
            >
              <div>
                <h3 className="text-2xl lg:text-3xl font-bold text-[#E85A2C] mb-4">
                  Healthcare Brand Guidelines & Assets
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  We deliver comprehensive medical brand guidelines and all assets you need. This ensures brand consistency across your practice staff and any future healthcare marketing maintains your established professional identity.
                </p>
              </div>
            </motion.div>
          </div>

        </div>
      </section>

      {/*  FAQ SECTION  */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          
          {/* Section Header */}
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl font-bold text-[#19354a]">
              Frequently Asked Questions about
            </h2>
            <h3 className="text-3xl lg:text-4xl font-bold text-[#19354a]">
              Healthcare Creative Services.
            </h3>
          </motion.div>

          {/* FAQ Content - Image Left, Questions Right */}
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            
            {/* Left - Image */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="flex justify-center lg:sticky lg:top-24"
            >
              <img 
                src="/images/faq-img.png" 
                alt="FAQ Healthcare Creative"
                className="w-full max-w-[220px] h-auto"
              />
            </motion.div>

            {/* Right - FAQ Items */}
            <div className="space-y-4">
              {[
                {
                  question: "What's included in a medical practice brand identity package?",
                  answer: "Our healthcare brand identity package includes professional medical logo design (primary and variations), color palette, typography selection, brand guidelines document, business card designs, and patient-facing stationery. We customize packages based on your specialty and practice needs."
                },
                {
                  question: "Do you understand healthcare compliance for creative materials?",
                  answer: "Yes! Our team is well-versed in healthcare marketing regulations including HIPAA compliance, patient privacy standards, and medical advertising guidelines. All creative materials are designed to meet healthcare industry standards while maintaining visual appeal."
                },
                {
                  question: "Can you create patient education materials and health content?",
                  answer: "Absolutely! We specialize in creating clear, accurate patient education materials including procedure explanations, health condition infographics, wellness tips, and preventive care content that patients can understand and trust."
                },
                {
                  question: "What types of medical videos can you produce?",
                  answer: "We produce patient testimonial videos, practice tour videos, medical procedure explanations, doctor introduction videos, health education content, and promotional videos for healthcare services. All content is professional and HIPAA-compliant."
                },
                {
                  question: "How do you ensure brand consistency across our medical practice?",
                  answer: "We provide comprehensive brand guidelines that cover logo usage, color specifications, typography, imagery style, and tone of voice. This ensures everyone on your healthcare team maintains consistent branding across all patient touchpoints and marketing materials."
                }
              ].map((faq, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                >
                  <details className="group">
                    <summary className="flex items-center justify-between p-5 bg-[#19354a] rounded-lg cursor-pointer list-none">
                      <span className="font-semibold text-white">{faq.question}</span>
                      <span className="text-white text-2xl font-light group-open:hidden">+</span>
                      <span className="text-white text-2xl font-light hidden group-open:block">−</span>
                    </summary>
                    <div className="px-5 py-4 bg-gray-50 rounded-b-lg text-gray-700 leading-relaxed -mt-2">
                      {faq.answer}
                    </div>
                  </details>
                </motion.div>
              ))}
            </div>

          </div>
        </div>
      </section>

      {/*  CTA SECTION  */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.h2 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl lg:text-4xl font-bold text-[#19354a] mb-6"
          >
            Ready to Elevate Your Medical Practice Brand?
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-gray-600 text-lg mb-8"
          >
            Let our healthcare creative team bring your medical practice vision to life with professional visuals and compelling patient content.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link 
              to="/contact" 
              className="px-8 py-4 bg-[#19354a] text-white rounded-lg font-semibold hover:bg-[#0f2133] transition-all"
            >
              Get a Free Consultation
            </Link>
            <a 
              href="tel:+918920845297" 
              className="px-8 py-4 border-2 border-[#19354a] text-[#19354a] rounded-lg font-semibold hover:bg-[#19354a] hover:text-white transition-all"
            >
              Call Us Now
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CreativeMediaBranding;